import React from 'react';
import {Camera} from 'expo-camera';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const preloadCamera = async (cameraRef, onCameraReady) => {
  const {status} = await Camera.requestCameraPermissionsAsync();
  if (status === 'granted') {
    cameraRef.current = (
      <Camera
        ref={cameraRef}
        style={{width: 1, height: 1}}
        onCameraReady={onCameraReady}
      />
    );
  } else {
    console.error('Camera permission not granted');
  }
};

export const isPackingCamEnabled = async (scanpackSetting, storeDisablePackingCam, adminToolsPackingCam, psv2Modules) => {
  const packingCamEnabled = await AsyncStorage.getItem('packingCamEnabled');

  return (
    adminToolsPackingCam === true &&
    Array.isArray(psv2Modules) && psv2Modules.includes('packing_cam') &&
    packingCamEnabled !== 'false' &&
    scanpackSetting?.packing_cam_enabled === true &&
    scanpackSetting?.capture_image_option !== 'do_not_take_image' &&
    storeDisablePackingCam !== true
  );
};

export const preloadCameraIfEnabled = async (cameraRef, onCameraReady, scanpackSetting, storeDisablePackingCam, adminToolsPackingCam, psv2Modules) => {
  const enabled = await isPackingCamEnabled(scanpackSetting, storeDisablePackingCam, adminToolsPackingCam, psv2Modules);

  if (enabled) {
    await preloadCamera(cameraRef, onCameraReady);
    return true;
  }

  return false;
};
